import format from 'date-fns/format';
import isValid from 'date-fns/isValid';
import parseISO from 'date-fns/parseISO';
import parse from 'date-fns/parse';
import formatISO9075 from 'date-fns/formatISO9075';
import i18next from 'i18next';
import { enGB, de, es, pl, zhCN, ru } from 'date-fns/locale';
import { registerLocale } from 'react-datepicker';
import assign from "lodash/assign";
registerLocale('de', de);
registerLocale('en', enGB);
registerLocale('zh', zhCN);
registerLocale('es', es);
registerLocale('pl', pl);
registerLocale('ru', ru);
export var normalizeDate = function (date) {
    return typeof date === "string" ? parseISO(date) : date;
};
export var validateDate = function (date) {
    return isValid(normalizeDate(date));
};
export var dateFormat = function (date, formatString) {
    var locales = {
        en: enGB,
        zn: zhCN,
        es: es,
        pl: pl,
        ru: ru,
        de: de,
    };
    var locale = i18next.t("locale");
    var localeLanguage = locales[locale];
    registerLocale(locale, localeLanguage);
    return format(date, formatString, { locale: localeLanguage });
};
export var parseDate = function (date, format) {
    return parse(date, format, new Date);
};
export var dateToString = function (date, representation) {
    return formatISO9075(normalizeDate(date), { representation: representation });
};
export var getApiDateObject = function (date, representation) {
    return assign({}, {
        date: dateToString(date, representation),
        "timezone_type": 3,
        "timezone": "Europe/Berlin"
    });
};
export var dateObjectOrNull = function (date) {
    return date ? getApiDateObject(date) : null;
};
